import { module } from 'angular'
import 'angular-grid'
import 'angular-grid/dist/angular-grid.css'

export default module('kd.grid', [
  'angularGrid',
])



// WEBPACK FOOTER //
// ./src/kendu/grid/module.js